import image7 from "../images/Engineering-1.jpg";
import image8 from "../images/Engineering-2.jpg";
import { useState } from "react";

const Engineering = () => {
    const [block, setblock] = useState(false);

    function FullView(ImgLink){
        document.getElementById("FullImage4").src = ImgLink;
        setblock(true);
    }

    function CloseFullView(){
        setblock(false);
    }

    return ( 
        <>
            <div className="main-container">
                    <h2>Engineering</h2>
                    <div className="components-section">
                        <div className="comp">
                            <div className="component">Values</div>
                            <div className="list">
                                <ul>
                                    <li>Supply and delivery of :Ball valves, Globe valves, Butterfly valves, Pressure valves, Gate valves, Non return check valves, knife valves, Actuators valves, Vacuum valves etc</li>
                                </ul>
                            </div>
                        </div>
                        <div className="comp">
                            <div className="component second">Pumps</div>
                            <div className="list">
                                <ul>
                                    <li>Supply and delivery of : Boiler feed pumps, Cooling water pumps, Condensate pumps, Pressure pumps, Turbine pumps, Oil pumps, Fuel and Gas pumps, Sewage pumps, Gear pumps, Water pumps , Heating pumps etc</li>
                                </ul>
                            </div>
                        </div>
                        <div className="comp">
                            <div className="component">Pipes</div>
                            <div className="list">
                                <ul>
                                    <li>Supply and delivery of sewage pipes, steel pipes and water pipe and related components</li>
                                </ul>
                            </div>
                        </div>
                        <div className="comp">
                            <div className="component">Heat Exchangers</div>
                            <div className="list">
                                <ul>
                                    <li>Cleaning of sites before erection and clearing of site after erection</li>
                                </ul>
                            </div>
                        </div>
                    </div>

                    <div className="list">
                        <ul>
                            <li>We render our engineering and manufacturing services to public entities and private entities.
                            </li>
                            <li>
                                We render diversified engineering services ranging from basic to technical works
                            </li>
                            <li>
                                 We also render services of refurbishment of valves and pumps and other engineering components
                            </li>
                            <li>
                                We supply and calibrate pressure gauges, bore gauges, Vernier callipers etc.
                            </li>
                            <li>
                                We have rendered conveyor maintenance services and engineering services to various entities i.e. Ncamiso Mining, Gyproc etc.
                            </li>
                        </ul>
                    </div>
                    
                    <h3>Image Gallary </h3>
                    <h5>(Click image for fullscreen)</h5>
                    <div className="images">
                        <img src={image7} onClick={() => FullView(image7)} alt=""/>
                        <img src={image8} onClick={() => FullView(image8)} alt=""/>
                    </div>
                    <div className="fullImageView" style={{display: block? "block" : "none"}}>
                        <img id="FullImage4" alt=""  />
                        <i className="fa fa-times CloseButton" onClick={() => CloseFullView()}></i>
                    </div>
                </div>
                <div className="end-section4">
                </div>
            </>
     );
}
 
export default Engineering;